module.exports = __webpack_public_path__ + "img/image5.e45bf056.jpg";